import { AppBar, Container, Toolbar, Typography, useTheme } from '@mui/material'
import { ALERT_BANNER_HEIGHT_PX } from '@src/types/constants'

interface AlertBannerProps {
  message: string
  severity?: 'error' | 'info' | 'warning' | 'success'
  show?: boolean
}

const AlertBanner = ({ message, severity = 'error', show = true }: AlertBannerProps) => {
  const theme = useTheme()
  const barColor = severity === 'error' ? theme.palette.error.main : theme.palette.info.main

  return (
    <AppBar
      position="fixed"
      sx={[
        {
          backgroundColor: barColor,
          top: 0,
          zIndex: 1500,
        },
        show
          ? {
              display: 'flex',
            }
          : {
              display: 'none',
            },
      ]}
    >
      <Container maxWidth="xl" disableGutters>
        <Toolbar
          variant="dense"
          sx={{ minHeight: ALERT_BANNER_HEIGHT_PX, justifyContent: 'center', display: 'flex' }}
        >
          <Typography variant="h5" color="inherit">
            {message}
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default AlertBanner
